import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "app-main-scroll" }

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { UserRole } from '@/constants/roles';
import { useAuth } from '@/composables/useAuth';
interface SidebarUserPayload {
  user?: { last_name?: string; name?: string; email?: string };
}


const __default__ = { name: 'UiSidebar' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const { hasRole } = useAuth();
const dropdown = ref(false);

const userData = computed((): SidebarUserPayload => {
  const u = store.getters['user/userData'];
  if (u == null || (Array.isArray(u) && u.length === 0)) {
    return {};
  }
  return u as SidebarUserPayload;
});

function logout() {
  localStorage.removeItem('userData');
  store.commit('user/removeUserData');
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createBlock(_component_v_layout, {
    "full-height": "",
    class: "price-app-inner-layout"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_navigation_drawer, {
        permanent: "",
        color: "app-chrome",
        "expand-on-hover": "",
        rail: "",
        mobile: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                "prepend-icon": "mdi-account-circle",
                title: userData.value?.user?.last_name + ' ' + userData.value?.user?.name,
                subtitle: userData.value?.user?.email
              }, null, 8, ["title", "subtitle"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider),
          (_unref(hasRole)(_unref(UserRole).MANAGER))
            ? (_openBlock(), _createBlock(_component_v_list, {
                key: 0,
                density: "compact",
                nav: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-list-box",
                    title: "Прайс",
                    "router-link": "",
                    to: "/price/"
                  }),
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-exit-run",
                    title: "Выйти",
                    "router-link": "",
                    to: "/",
                    onClick: logout
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_v_list, {
                key: 1,
                density: "compact",
                nav: "",
                class: "sidebar__v-list"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-list-box",
                    title: "Прайс",
                    "router-link": "",
                    to: "/price/"
                  }),
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-list-box-outline",
                    title: "Номенклатура поставщиков",
                    "router-link": "",
                    to: "/scat/"
                  }),
                  _createVNode(_component_v_list_item, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (dropdown.value = !dropdown.value)),
                    density: "compact",
                    nav: "",
                    "prepend-icon": "mdi-tune-vertical-variant",
                    title: "Настройки"
                  }),
                  (dropdown.value)
                    ? (_openBlock(), _createBlock(_component_v_list, {
                        key: 0,
                        density: "compact",
                        nav: "",
                        class: "sidebar-nested-list"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-upload-circle-outline",
                            title: "Импорт",
                            "router-link": "",
                            to: "/upload/"
                          }),
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-truck-fast-outline",
                            title: "Поставщики",
                            "router-link": "",
                            to: "/suppliers/"
                          }),
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-file-xml-box",
                            title: "Фиды",
                            "router-link": "",
                            to: "/feeds/"
                          }),
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-function-variant",
                            title: "Формулы",
                            "router-link": "",
                            to: "/formulas/"
                          }),
                          _createVNode(_component_v_list_item, {
                            "prepend-icon": "mdi-cash-multiple",
                            title: "Курсы валют",
                            "router-link": "",
                            to: "/currencies/"
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_list_item, {
                    "prepend-icon": "mdi-exit-run",
                    title: "Выйти",
                    "router-link": "",
                    to: "/",
                    onClick: logout
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      _createVNode(_component_v_main, {
        class: "price-main-scroll-host flex-grow-1",
        style: {"min-height":"0"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_view)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})